import { ChevronDown20Regular } from "@fluentui/react-icons";

interface DetailsToggleProps {
  open: boolean;
  onToggle: () => void;
  // Used as the tooltip (title) + accessible name; e.g. "Ver detalhes" / "Ver linhas".
  showLabel?: string;
  hideLabel?: string;
}

// A bordered chevron icon-button (the border makes it read as a button) with a
// tooltip. Lives in a leading column so every expandable row has the SAME, single
// expand affordance — no text links cluttering the actions column.
export function DetailsToggle({
  open,
  onToggle,
  showLabel = "Ver detalhes",
  hideLabel = "Ocultar detalhes",
}: DetailsToggleProps) {
  const label = open ? hideLabel : showLabel;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={label}
      title={label}
      className="inline-flex items-center justify-center min-h-[44px] px-3 bg-secondary hover:bg-accent border border-border rounded transition-colors cursor-pointer"
      style={{ borderRadius: "var(--radius-button)" }}
    >
      <ChevronDown20Regular
        className="w-5 h-5 text-secondary-text"
        style={{ transform: open ? "rotate(180deg)" : undefined, transition: "transform 0.15s" }}
      />
    </button>
  );
}
